import React from "react";
import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";
import { PREFERENCE_KEYS, savePreference } from "../../lib/preferences";
import { ICON_BUTTON } from "../ui/styles";

const LanguageToggle = ({ scrolled = true, icon = false }) => {
  const { i18n } = useTranslation();
  const target = i18n.language === "en" ? "العربية" : "English";

  const toggleLang = () => {
    const newLang = i18n.language === "en" ? "ar" : "en";
    i18n.changeLanguage(newLang);
    savePreference(PREFERENCE_KEYS.lang, newLang);
    document.documentElement.dir = newLang === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = newLang;
  };

  if (icon) {
    return (
      <button
        type="button"
        onClick={toggleLang}
        aria-label={target}
        title={target}
        className={ICON_BUTTON}
      >
        <Languages size={18} />
      </button>
    );
  }

  return (
    <button
      onClick={toggleLang}
      className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 border ${
        scrolled
          ? "border-gray-200 text-gray-700 hover:border-accent hover:text-accent bg-white"
          : "border-white/30 text-white/90 hover:border-accent hover:text-accent bg-white/10"
      }`}
    >
      <span>{i18n.language === "en" ? "عربي" : "EN"}</span>
    </button>
  );
};

export default LanguageToggle;
